export default "__VITE_ASSET__B_bx2xoV__"